import React, { useContext, useEffect, useState } from 'react';
import { WizardContext } from 'context/Context';
import { useNavigate } from 'react-router-dom';
import { Form, Row, Button, Alert } from 'react-bootstrap';
import Wrapper from './components/Wrapper';
import { getTimeWindow } from './components/Confirmed';
import { ConfigContext } from 'context/Context';
import Video2 from './components/Video2';

function ConfirmInstall() {
  const { fabricator } = useContext(ConfigContext);
  const { job, handleAppointmentConfirmation } = useContext(WizardContext);
  const navigate = useNavigate();
  const [decision, setDecision] = useState('');
  const [rescheduleConfirm, setRescheduleConfirm] = useState(false);
  const [reason, setReason] = useState('');
  const [decided, setDecided] = useState(false);

  useEffect(() => {
    // console.log('install status', job?.install?.status);
    console.log('job', job);
    if (
      job.id &&
      (!job.install ||
        job?.install?.reschedule ||
        job?.install?.status === 'Installed' ||
        job?.install?.status === 'In Progress')
    ) {
      navigate('../');
    }
  }, [job.id, job?.install?.status]);

  useEffect(() => {
    if (job?.install?.windowAnswered) {
      setDecided(true);
      if (job.install.windowConfirmed) {
        setDecision('confirm');
      } else if (job.install.reschedule) {
        setDecision('reschedule');
        navigate('../');
      } else {
        navigate('../');
      }
    }
  }, [job?.install]);

  return decided ? (
    <Wrapper>
      <div className="container">
        <h5>Install Arrival Window Confirmed</h5>
        <p>
          Fantastic - we look forward to seeing you! Check out this little video
          for more information on how to be ready:
        </p>
        <Video2
          file={
            'https://library.countertopwizard.com/OtherAsset%2Fcw-confirmations%2FInstall%20Explainer.mp4'
          }
        />

        <p>Quick Checklist to be ready:</p>
        <ul>
          <li>Sink, faucet, & range on-site</li>
        </ul>
        {/* {job?.sinkInfo?.type?.match(/farm/) && (
          <Alert variant="secondary">
            Since you are supplying a farm sink, it needs to be resting in place
            but not glued down when our technician comes to measure.
          </Alert>
        )} */}
        {job?.cabinetInfo?.type?.match(/old/) &&
          job?.tearoutInfo?.status !== 'yes' && (
            <ul>
              <li>Have all existing cabinets cleared off</li>
              <li>
                Remove any top drawers and clean out the top shelf of the
                cabinet{' '}
              </li>
            </ul>
          )}
        {job?.cabinetInfo?.type?.match(/old/) &&
          job?.tearoutInfo?.status === 'yes' && (
            <ul>
              <li>
                Have all existing countertops and backsplash removed to cabinet
                base
              </li>
            </ul>
          )}
        {job?.cabinetInfo?.type?.match(/new/) && (
          <ul>
            <li>New cabinets fully installed including all end panels</li>
          </ul>
        )}
        <ul>
          <li>Decision-maker (18+) on-site for the entire appointment</li>
        </ul>
        <Alert variant="secondary">
          Note: If we’re unable to install due to unpreparedness, there will be
          an "unable to install" fee.
        </Alert>
        <p>
          See you soon! If you have questions, please reach out to your project
          coordinator, {job?.PC.firstName} at{' '}
          <a href={`tel:1-${job?.PC?.phone || '800-548-4445'}`}>
            {job?.PC?.phone || '800.548.4445'}
          </a>
          .
        </p>
        <p style={{ fontStyle: 'italic' }}>
          If you have an emergency that requires you to reschedule, please call{' '}
          <a href={fabricator.phonelink}>{fabricator.phone}</a>
        </p>
      </div>
    </Wrapper>
  ) : (
    <Wrapper>
      <div className="container">
        <h5>Confirm Install Arrival Window</h5>

        <Row>
          <p>
            Exciting news - it’s installation time! Your Countertop Installation
            is scheduled for
            {job?.install?.dateFormatted}, and our team will be arriving between{' '}
            <strong>
              {job?.install?.time && getTimeWindow(job?.install?.time)}
            </strong>{' '}
            to bring your space to life!
          </p>
          <p className="fs--1">
            Click your choice below to move forward with your project:
          </p>
        </Row>

        <Form className="outdoor-field">
          <Row className="pl-3">
            <Form.Check
              type="radio"
              name="decision"
              id="confirm"
              label={`Perfect - see you there`}
              checked={decision === 'confirm'}
              onChange={() => {
                setDecision('confirm');
              }}
            />
          </Row>
          <Row className="pl-3">
            <Form.Check
              type="radio"
              name="reschedule"
              id="yes"
              label={<>I need to reschedule</>}
              checked={decision === 'reschedule'}
              onChange={() => {
                setDecision('reschedule');
              }}
            />
          </Row>
        </Form>
        {decision === 'reschedule' && (
          <>
            <p>Are you sure you need to reschedule?</p>
            <p>
              Just a heads up - if we reschedule, we'll have to find the next
              available date.
            </p>
            <Form>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  id="textOK"
                  label="Yes, please contact me to reschedule"
                  checked={rescheduleConfirm}
                  onChange={({ target }) =>
                    setRescheduleConfirm(target.checked)
                  }
                  inline
                />
              </Form.Group>
              {rescheduleConfirm && (
                <>
                  <p className="fs--1" style={{ fontStyle: 'italic' }}>
                    Are there any scheduling concerns we should be aware of
                    while we look for a new date for you?{' '}
                  </p>
                  <Form.Group>
                    <Form.Control
                      as="textarea"
                      bssize="sm"
                      id="experienceDescription"
                      value={reason}
                      onChange={({ target }) => setReason(target.value)}
                      rows={5}
                      className="mb-3"
                    />
                  </Form.Group>
                </>
              )}
            </Form>
          </>
        )}
        <Button
          color="primary"
          className="mx-2 my-1 save-comment-btn"
          disabled={
            !decision || (decision === 'reschedule' && !rescheduleConfirm)
          }
          onClick={() => {
            handleAppointmentConfirmation({
              type: 'install',
              decision,
              reason
            });
            if (decision === 'confirm') {
              setDecided(true);
            } else {
              navigate('../');
            }
          }}
        >
          Submit My Selection
        </Button>
      </div>
    </Wrapper>
  );
}

export default ConfirmInstall;
